module.exports = __webpack_public_path__ + "static/media/mobile.e794b40a.png";